import { useState, useEffect } from "react";
import { IconButton, Chip, Checkbox, Button } from "@material-ui/core";
import { Download } from "@mui/icons-material";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import {
  columnPriceField,
  columnDateField,
  columnTextField,
} from "utils/tables-utils";
import { LONGTERM_STATUS } from "./table-view";

export default function TableSummarized({
  data,
  downloadBoleto,
  onExportBoletos,
  totalRegistros,
  page,
  sizePerPage,
}) {
  const [dataTable, setDataTable] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    setDataTable(
      data?.map((item) => ({
        ...item,
        selected: false,
      }))
    );
    setSelectAll(false);
  }, [data]);

  const handleSelectRow = (id) => {
    setDataTable((prevData) =>
      prevData?.map((item) =>
        item.IdTitulo === id ? { ...item, selected: !item.selected } : item
      )
    );
  };

  const handleSelectAll = () => {
    setDataTable((prevData) =>
      prevData?.map((item) => ({
        ...item,
        selected: !selectAll,
      }))
    );
    setSelectAll(!selectAll);
  };

  const columnModel = [
    {
      dataField: "selected",
      text: "",
      align: "center",
      headerAlign: "center",
      formatter: (_, row) => (
        <Checkbox
          checked={row.selected}
          onChange={(e) => {
            e.stopPropagation();
            handleSelectRow(row.IdTitulo);
          }}
          onClick={(e) => e.stopPropagation()}
          color="primary"
        />
      ),
      headerFormatter: () => (
        <Checkbox
          checked={selectAll}
          onChange={handleSelectAll}
          color="primary"
        />
      ),
      style: {
        width: "5vw",
      },
    },
    columnTextField({
      dataField: "boleto",
      text: "Boleto",
      align: "center",
      formatter: (_, row) => {
        return (
          <IconButton
            color="primary"
            onClick={() => {
              downloadBoleto(row.UrlDownloadBoleto);
            }}
            size="small"
            style={{ cursor: "pointer" }}
          >
            <Download fontSize="small" color="textPrimary" />
          </IconButton>
        );
      },
    }),
    columnTextField({
      dataField: "NumeroTituloOuNF",
      text: "Título / NF",
      align: "center",
      formatter: (_, row) => {
        const titulo = row.NumeroTitulo || "";
        const nf = row.NumeroNf || "";
        if (titulo && nf) {
          return `${titulo} / ${nf}`;
        } else if (titulo) {
          return titulo;
        } else if (nf) {
          return nf;
        }
        return "";
      },
    }),
    columnTextField({
      dataField: "Situacao",
      text: "Status",
      align: "center",
      formatter: (_, row) => {
        const isPaid = row.Situacao === "LQ";
        const isPending = row.Situacao === "AB";
        const isCanceled = row.Situacao === "CA";

        let backgroundColor, borderColor;

        if (isPaid) {
          backgroundColor = "rgba(0, 128, 0, 0.1)";
          borderColor = "1px solid rgba(0, 128, 0, 0.5)";
        } else if (isPending) {
          backgroundColor = "rgba(255, 193, 7, 0.1)";
          borderColor = "1px solid rgba(255, 193, 7, 0.5)";
        } else if (isCanceled) {
          backgroundColor = "rgba(244, 67, 54, 0.1)";
          borderColor = "1px solid rgba(244, 67, 54, 0.5)";
        } else {
          backgroundColor = "rgba(128, 128, 128, 0.1)";
          borderColor = "1px solid rgba(128, 128, 128, 0.5)";
        }

        return (
          <Chip
            label={LONGTERM_STATUS.get(row.Situacao)}
            size="small"
            style={{
              width: "100px",
              padding: "1rem 0.5rem",
              backgroundColor: backgroundColor,
              border: borderColor,
            }}
          />
        );
      },
    }),
    columnDateField({
      dataField: "DtVencimento",
      text: "Vencimento",
      align: "center",
    }),
    columnPriceField({
      dataField: "Valor",
      text: "Valor",
      align: "center",
    }),
  ];
  return (
    <ToolkitTable
      dataTable={dataTable}
      headerTitle="Títulos"
      keyField="IdTitulo"
      columnModel={columnModel}
      pagination={{
        options: [10, 25, 50, 100],
        defaultOption: sizePerPage,
        totalSize: totalRegistros,
        page: page,
        sizePerPage: sizePerPage,
        showTotal: true,
      }}
      notFoundTitle="Sua busca não encontrou nenhum resultado correspondente."
      showPrint
      showExport
      csvFileName="RelatorioAcompanhamentoTitulos.csv"
      extraActions={
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            const selectedRows = dataTable?.filter((item) => item.selected);
            if (onExportBoletos && selectedRows?.length > 0) {
              onExportBoletos(selectedRows);
            }
          }}
          disabled={!dataTable?.some((item) => item.selected)}
        >
          Exportar boletos
        </Button>
      }
    />
  );
}
